import React from 'react'

const ClockIcon = (props) => {
  return (
    <svg className={props.className} viewBox="0 0 22 22">
      <path d="M11,22A11,11,0,1,1,22,11,11,11,0,0,1,11,22ZM11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Z"/>
      <path d="M15,14a.93.93,0,0,1-.45-.11l-4-2A1,1,0,0,1,10,11V5a1,1,0,0,1,2,0v5.38l3.45,1.73a1,1,0,0,1,.44,1.34A1,1,0,0,1,15,14Z"/>
    </svg>
  )
}

export default ClockIcon


// WEBPACK FOOTER //
// ./src/assets/icons/clock-icon.js